import Slider from '../../UIKitRefresh/Slider/Slider';
import {
  BUILDING_TYPE_PROJECT,
  BUILDING_TYPE_NEW_BUILDING,
  BUILDING_TYPE_COTTAGE,
} from '../constants';

import { sendRealtyTypeClickEvents, sendRealtyTypePageViewEvents } from './sendRealtyTypeEvents';

class FunnelFilters {
  constructor(options) {
    this.root = document.querySelector('[data-funnel="filters"]');
    this.projectNode = this.root.querySelector(`[data-realty-type="${BUILDING_TYPE_PROJECT}"]`);
    this.newBuildingNode = this.root.querySelector(
      `[data-realty-type="${BUILDING_TYPE_NEW_BUILDING}"]`,
    );
    this.cottageNode = this.root.querySelector(`[data-realty-type="${BUILDING_TYPE_COTTAGE}"]`);
    this.toggles = this.nodesByRealtyType('data-toggle');
    this.switches = this.nodesByRealtyType('data-switch');
    this.sliders = this.nodesByRealtyType('data-slider');
    this.slidersToReset = this.nodesByRealtyType();
    this.resetButtons = this.root.querySelectorAll('[data-reset]');
    this.realtyTypeChips = [...this.root.querySelectorAll('[data-chip-realty-type]')];
    this.onToggle = options.onToggle;
    this.onSwitch = options.onSwitch;
    this.onReset = options.onReset;
    this.onAssign = options.onAssign;
    this.onRealtyTypeChange = options.onRealtyTypeChange;
    this.modal = options.modal;
    this.attachEvents();
  }

  nodesByRealtyType(key) {
    return {
      [BUILDING_TYPE_PROJECT]: key ? [...this.projectNode.querySelectorAll(`[${key}]`)] : [],
      [BUILDING_TYPE_NEW_BUILDING]: key
        ? [...this.newBuildingNode.querySelectorAll(`[${key}]`)]
        : [],
      [BUILDING_TYPE_COTTAGE]: key ? [...this.cottageNode.querySelectorAll(`[${key}]`)] : [],
    };
  }

  attachEvents() {
    this.initSwitcher();

    Object.values(this.toggles).forEach((toggles) => {
      toggles.forEach((toggle) => {
        const [key, value] = toggle.getAttribute('data-toggle').split('|');
        const isCheckbox = toggle.getAttribute('type') === 'checkbox';
        if (isCheckbox) {
          toggle.addEventListener('change', () => {
            this.onToggle(key, value);
          });
        } else {
          toggle.addEventListener('click', (event) => {
            event.preventDefault();
            toggle.classList.toggle('-active');
            this.onToggle(key, value);
          });
        }
      });
    });

    Object.values(this.switches).forEach((switches) => {
      switches.forEach((sw) => {
        sw.addEventListener('click', () => {
          this.toggleSwitch(sw);
        });
      });
    });

    Object.entries(this.sliders).forEach(([realtyType, sliders]) => {
      sliders.forEach((node) => {
        const sliderNode = node.querySelector('[data-slider-initial]');
        const minValueNode = node.querySelector('[data-value-min]');
        const maxValueNode = node.querySelector('[data-value-max]');
        const sliderKey = node.getAttribute('data-slider');
        const keys = [`min_${sliderKey}`, `max_${sliderKey}`];
        const slider = new Slider(sliderNode, keys, {
          onUpdate: ({ min, max }) => {
            minValueNode.textContent = `${min}${sliderKey === 'area' ? ' м²' : ''}`;
            maxValueNode.textContent = `${max}${sliderKey === 'area' ? ' м²' : ''}`;
          },
          onChange: (key, value) => {
            this.onAssign(key, value);
          },
        });
        this.slidersToReset[realtyType].push(slider);
      });
    });

    [].forEach.call(this.resetButtons, (button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.reset();
        this.onReset(this.resetKeys);
        this.resetRealtyType();
        this.modal.close();
      });
    });

    this.realtyTypeChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        sendRealtyTypeClickEvents(chip.getAttribute('data-chip-realty-type'));
      });
    });
  }

  toggleSwitch(sw) {
    if (!sw) return;

    const key = sw.getAttribute('data-switch');
    sw?.classList?.toggle('-active');
    this.onSwitch(key);
  }

  initSwitcher() {
    const switchers = document.querySelectorAll('[data-switcher=realty]');
    if (!switchers.length) return;
    const realtyTypeFilters = [...this.root.querySelectorAll('[data-realty-type]')];

    const handleChange = (currentType, sourceSwitcher) => {
      window.params.buildingType = currentType;
      realtyTypeFilters.forEach((realtyType) => realtyType.classList.add('hidden'));
      this.root.querySelector(`[data-realty-type="${currentType}"]`).classList.remove('hidden');

      // sync switchers in modal and in search bar
      switchers.forEach((switcher) => {
        const input = switcher.querySelector('input');

        if (input.value !== currentType) {
          input.value = currentType;
        }

        const chips = switcher.querySelectorAll('[data-toggle-chip-id]');
        chips.forEach((chip) => {
          chip.classList.toggle(
            '-active',
            chip.getAttribute('data-toggle-chip-id') === currentType,
          );
        });

        const apartmentsChip = switcher.querySelector('[data-apartments-chip]');
        if (apartmentsChip) apartmentsChip.classList.remove('-active');
        const townhouseChip = switcher.querySelector('[data-townhouse-chip]');
        if (townhouseChip) townhouseChip.classList.remove('-active');
      });

      this.updateUrl(sourceSwitcher.querySelector(`[data-toggle-chip-id="${currentType}"]`));
    };

    switchers.forEach((switcher) => {
      const input = switcher.querySelector('input');

      if (!window.params.buildingType) {
        window.params.buildingType = input.value;
      }

      input.addEventListener('change', () => {
        handleChange(input.value, switcher);
      });
    });
  }

  resetRealtyType() {
    const switcher = this.root.querySelector('[data-switcher=realty]');
    if (!switcher || window.params.buildingType === BUILDING_TYPE_PROJECT) return;
    const input = switcher.querySelector('input');
    const currentType = input.value;
    input.value = BUILDING_TYPE_PROJECT;
    [currentType, BUILDING_TYPE_PROJECT].forEach((realtyType) =>
      switcher.querySelector(`[data-toggle-chip-id="${realtyType}"]`).classList.toggle('-active'),
    );
    input.dispatchEvent(new Event('change'));
  }

  updateUrl(toggle) {
    const [catalogUrl] = toggle.dataset.catalogUrl.split('?');
    const [mapUrl] = toggle.dataset.mapUrl.split('?');
    const pageType = toggle.dataset.toggleChipId;

    window.params.mapUrl = mapUrl;
    window.params.catalogUrl = catalogUrl;
    window.params.geoUrl = window.params.type === 'map' ? mapUrl : catalogUrl;

    sendRealtyTypePageViewEvents(pageType);

    this.onRealtyTypeChange({
      ...window.params.queryForRealtyTypeChange,
    });
  }

  count() {
    const count = [];
    const { buildingType } = window.params;
    const toggles = this.toggles[buildingType];
    const switches = this.switches[buildingType];
    const slidersToReset = this.slidersToReset[buildingType];

    if (buildingType !== BUILDING_TYPE_PROJECT) {
      count.push('buildingType');
    }

    toggles.forEach((toggle) => {
      const isCheckbox = toggle.getAttribute('type') === 'checkbox';
      if ((isCheckbox && toggle.checked) || toggle.classList.contains('-active')) {
        const [key] = toggle.getAttribute('data-toggle').split('|');
        if (count.indexOf(key) === -1) count.push(key);
      }
    });

    switches.forEach((sw) => {
      if (sw.classList.contains('-active')) {
        count.push(sw.getAttribute('data-switch'));
      }
    });

    slidersToReset.forEach((slider) => {
      const values = slider.node.noUiSlider.get();
      const range = (value) => (Array.isArray(value) ? value[0] : value);
      if (values[0] !== range(slider.range.min) || values[1] !== range(slider.range.max)) {
        count.push(slider.keys[0]);
      }
    });

    return count.length;
  }

  reset() {
    this.resetKeys = {};
    Object.values(this.toggles).forEach((toggles) => {
      toggles.forEach((toggle) => {
        const isCheckbox = toggle.getAttribute('type') === 'checkbox';
        const [key] = toggle.getAttribute('data-toggle').split('|');
        if (isCheckbox) {
          toggle.checked = false;
        } else {
          toggle.classList.remove('-active');
        }
        this.resetKeys[key] = [];
      });
    });
    Object.values(this.switches).forEach((switches) => {
      switches.forEach((sw) => {
        const key = sw.getAttribute('data-switch');
        sw.classList.remove('-active');
        this.resetKeys[key] = false;
      });
    });
    Object.values(this.slidersToReset).forEach((sliders) => {
      sliders.forEach((slider) => {
        slider.reset();
        slider.keys.forEach((key) => {
          this.resetKeys[key] = false;
        });
      });
    });
  }
}

export default FunnelFilters;
